import React, { useCallback, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import { apiUrl } from "../../../config/Config";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Feedback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [rowData, setRowData] = useState([]);
  const [showloding, setshowloding] = useState(false);
  const paginationPageSizeSelector = useMemo(() => [10, 20, 50, 100], []);

  const headers = useMemo(() => ({
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userdata?.token,
    },
  }), [userdata?.token]);

  const handleInvalidUser = useCallback((message) => {
    if (message === "invalid user") {
      dispatch({ type: "userdata", payload: {} });
      navigate("/admin/login");
      return true;
    }
    return false;
  }, [dispatch, navigate]);

  const fetchFeedbacks = useCallback(async () => {
    setshowloding(true);
    await axios
      .get(apiUrl + "admingetfeedbacks", headers)
      .then((res) => {
        if (res.data.status === "success") {
          setRowData(res.data.data || []);
        } else if (!handleInvalidUser(res.data.message)) {
          alert(res.data.message);
        }
      })
      .catch((err) => alert(err.message));
    setshowloding(false);
  }, [handleInvalidUser, headers]);

  const deleteFeedback = async (id) => {
    const result = window.confirm("Delete this feedback?");
    if (!result) return;

    setshowloding(true);
    await axios
      .post(apiUrl + "admindeletefeedback", { id }, headers)
      .then((res) => {
        if (res.data.status === "success") {
          fetchFeedbacks();
        } else if (!handleInvalidUser(res.data.message)) {
          alert(res.data.message);
        }
      })
      .catch((err) => alert(err.message));
    setshowloding(false);
  };

  useEffect(() => {
    fetchFeedbacks();
  }, [fetchFeedbacks]);

  const columns = [
    { field: "fullname", headerName: "Name", minWidth: 180 },
    { field: "email", headerName: "Email", minWidth: 220 },
    { field: "mobile", headerName: "Mobile", minWidth: 140 },
    {
      field: "rating",
      headerName: "Rating",
      minWidth: 120,
      cellRenderer: (props) => (
        <span className="admin-rating-cell"><FontAwesomeIcon icon={faStar} /> {props.data.rating || "-"}</span>
      ),
    },
    { field: "feedback", headerName: "Feedback", minWidth: 320 },
    {
      field: "created_at",
      headerName: "Date",
      minWidth: 170,
      cellRenderer: (props) => props.data.created_at ? moment(props.data.created_at).format("DD MMM YYYY, hh:mm A") : "-",
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      cellRenderer: (props) => (
        <div className="admin-grid-actions">
          <button title="Delete feedback" className="danger" onClick={() => deleteFeedback(props.data.id)}>
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="dashboardbox" style={{ width: "100%" }}>
      <div className="dashboardboxtitlerow">
        <div>
          <p className="dashboardboxtitle">User Feedback</p>
          <p className="dashboardboxsubtitle">Ratings and comments submitted from the app</p>
        </div>
        {showloding ? <div className="moderation-loader"><Spinner color="#34A853" size={18} /></div> : null}
      </div>

      <div className="ag-theme-quartz mt-4" style={{ width: "100%", height: 560 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columns}
          defaultColDef={{ flex: 1, filter: true, sortable: true, resizable: true }}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={paginationPageSizeSelector}
          rowHeight={54}
        />
      </div>
    </div>
  );
};

export default Feedback;
